<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="selectedUrl ? `/request/${inputs.id}` : '/request'"
      >
        <div class="row">
          <div class="col-md-12">
            <app-note
              class="mb-primary"
              title="Información"
              content-type="html"
              :notes="[$store.getters.getTag('2.O')]"
            />
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Organización</label>
              <multiselect
                v-model="inputs.org_id"
                :options="orgs"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <!-- <div class="col-12">
            <div class="form-group">
              <label>Localización</label>
              <multiselect
                v-model="inputs.location"
                :options="locationList"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div> -->

          <!-- <div class="col-12">
            <div class="form-group">
              <label>Sector</label>
              <multiselect
                v-model="inputs.level2"
                :options="scopes.level2"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div> -->

          <div class="col-12">
            <div class="form-group">
              <label>Categoría</label>
              <multiselect
                v-model="inputs.level3"
                :options="scopes.level3"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Campo de calibración (1)</label>
              <multiselect
                v-model="inputs.level4"
                :options="scopes.level4"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Magnitud y Submagnitud (2)</label>
              <multiselect
                v-model="inputs.level5"
                :options="scopes.level5"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12 mb-5">
            <div class="form-group">
              <label
                >Rango de Medida (3)
          </label
              >
              <!-- <app-input
                type="textarea"
                v-model="inputs.level7"
                :required="true"
                placeholder="Ingrese Intervalo"
              /> -->
              <quill-editor
                v-model="inputs.level7"
                :options="editorOption"
                style="background: white; color: black"
              />
            </div>
          </div>
          <br/><br/><br/>
          <div class="col-12" style="margin-top: 40px">
            <div class="form-group">
              <label>Incertidumbre (4)</label>
              <!-- <app-input
                type="textarea"
                v-model="inputs.level8"
                :required="true"
                placeholder="Ingrese Incertidumbre"
              /> -->
              <quill-editor
                v-model="inputs.level8"
                :options="editorOption"
                style="background: white; color: black"
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 90px">
            <div class="form-group">
              <label>Instrumentos (5)</label>
              <app-input
                type="multi-select"
                :list="scopes.level6"
                :isAnimatedDropdown="true"
                v-model="inputs.level_6_selected"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Método Interno (5)</label>
              <app-input
                type="textarea"
                v-model="inputs.level9"
                :required="true"
                placeholder="Ingrese el Método Interno"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Método Referencia (revisión/edición) (5)</label>
              <app-input
                type="textarea"
                v-model="inputs.level10"
                :required="true"
                placeholder="Ingrese Método Referencia"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import Multiselect from "vue-multiselect";
import LiquorTree from "liquor-tree";
import { quillEditor } from "vue-quill-editor";

export default {
  components: { Multiselect, LiquorTree, quillEditor },
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        level_6_selected: [],
      },
      scopes: {
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: [],
      },
      orgs: [],
      modalId: "add-edit-modal",
      disabledSubmit: false,
      // locationList: [
      //   { id: "Laboratorio Matriz", value: "Laboratorio Matriz" },
      //   { id: "Unidades Técnicas", value: "Unidades Técnicas" },
      // ],
      editorOption: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline"],
            [{ align: [] }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        },
        theme: "snow", // snow or bubble
      },
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  created() {
    this.getData();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      const tmp = {
        ...this.inputs,
        acc_app_id: this.$store.state.accreditation.id,
      };
      tmp.org_id = this.getId(tmp.org_id);
      // tmp.level2 = this.getId(tmp.level2);
      tmp.level2 = 384;
      tmp.level3 = this.getId(tmp.level3);
      tmp.level4 = this.getId(tmp.level4);
      tmp.level5 = this.getId(tmp.level5);
      tmp.level6 = this.getId(tmp.level6);

      // Validar multi-select
      if (
        // !tmp.level2 ||
        !tmp.level3 ||
        !tmp.level4 ||
        !tmp.level5 ||
        tmp.level_6_selected.length == 0 ||
        !tmp.level7 ||
        !tmp.level8 ||
        !tmp.level9 ||
        !tmp.level10
        // || !tmp.location
      ) {
        this.$toastr.e("Todos los campos son obligatorios");
        return;
      }

      // tmp.location = this.inputs.location.value;

      this.disabledSubmit = true;
      this.save(tmp);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.preloader = false;

      const tmp = {};
      tmp.id = response.data.id;
      tmp.org_id = response.data.org;
      if (!tmp.org_id) {
        tmp.org_id = { id: null, value: "Matriz" };
      }
      tmp.level2 = response.data.level_2;
      tmp.level3 = response.data.level_3;
      tmp.level4 = response.data.level_4;
      tmp.level5 = response.data.level_5;
      tmp.level7 = response.data.level7;
      tmp.level8 = response.data.level8;
      tmp.level9 = response.data.level9;
      tmp.level10 = response.data.level10;
      tmp.location = response.data.location;
      // if (response.data.location) {
      //   tmp.location = {
      //     id: response.data.location,
      //     value: response.data.location,
      //   };
      // }
      tmp.level_6_selected = response.data.level_6_selected.map(
        (item) => item.acc_scope_master_id
      );

      this.inputs = tmp;
    },

    getData() {
      this.preloader = true;

      this.axiosGet(
        `request/options?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            const {
              data: { scopes, orgs },
            } = response;
            this.scopes = scopes;
            this.orgs = [{ id: null, value: "Matriz" }, ...orgs];
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    getId(item) {
      return item ? item.id : null;
    },
  },
};
</script>
